import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Hide({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        d="M17.1113 21.8897L15.3652 18.8653C14.2936 19.1703 13.1654 19.3333 12 19.3333C7.12212 19.3333 2.898 16.4784 0.74108 12.3061C0.641808 12.1141 0.641808 11.8859 0.74108 11.6938C2.21874 8.8355 4.66661 6.59544 7.63021 5.46804L5.79757 2.2938L6.95227 1.62714L18.266 21.2231L17.1113 21.8897ZM13.5347 15.695L14.6748 17.6696C13.816 17.8857 12.9203 18 12 18C7.7823 18 4.08148 15.5997 2.08931 12C3.47177 9.50201 5.67706 7.58159 8.30688 6.64007L9.56783 8.82409C8.61457 9.5552 7.99996 10.7058 7.99996 12C7.99996 14.2091 9.79082 16 12 16C12.5437 16 13.0621 15.8915 13.5347 15.695Z"
        fill={iconColor}
      />
      <Path
        d="M17.8463 17.8564C20.1442 16.6182 22.0345 14.6744 23.2588 12.3061C23.3581 12.1141 23.3581 11.8859 23.2588 11.6938C21.1019 7.52157 16.8778 4.66666 12 4.66666C11.423 4.66666 10.8553 4.7066 10.299 4.78393L11.0259 6.04298C11.3471 6.01451 11.672 5.99999 12 5.99999C16.2176 5.99999 19.9184 8.40033 21.9106 12C20.7976 14.0112 19.1511 15.648 17.1792 16.7009L17.8463 17.8564Z"
        fill={iconColor}
      />
    </Svg>
  );
}
